export enum PalletFillingType {
    FULL = 'Full',
    BOTTOM = 'Bottom',
    TOP = 'Top'
}
